module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAUElEQVQ4jWNgGAWMMIanp+d/bAq2b9/OiMz39PT8jyzGiKkFN0C2BN1gBk9Pz//oGJtmdJpkgK6RBZcEhhOpBYhyAc1sx+YCJmQJskN2aAMAdYAsH3Osp6YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-sort-desc.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-sort-desc.png
// module chunks = styles